import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { DatePipe } from '@angular/common';

import {
  JourneyStep,
  PreApplicationJourney,
} from '../../../../../core/applications/pre-application.types';
import { IconComponent, IconName } from '../../../../../shared/icon/icon';

const LANES: { key: JourneyStep['lane']; label: string }[] = [
  { key: 'client', label: 'Client' },
  { key: 'system', label: 'System' },
  { key: 'capx', label: 'CapX' },
];

const STATE_LABEL: Record<JourneyStep['state'], string> = {
  done: 'Done',
  current: 'Waiting here',
  upcoming: 'Expected next',
  branch: 'Possible branch',
};

/** The icon inside each step's tick box; an upcoming or branch step's box is empty. */
const MARKER: Partial<Record<JourneyStep['state'], IconName>> = {
  done: 'check',
  current: 'clock',
};

/**
 * The journey flowchart: one row per phase, one column per kind of actor
 * (the client, the system, CapX), time running down. Each step names who the
 * rule has act and the provision it rests on. Presentational — every state
 * comes from `applications/journey.py`, nothing is derived here beyond
 * grouping steps into their lane.
 */
@Component({
  selector: 'app-pre-application-journey',
  imports: [DatePipe, IconComponent],
  templateUrl: './journey.html',
  styleUrl: './journey.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreApplicationJourneyComponent {
  readonly journey = input.required<PreApplicationJourney>();
  /** The state legend; off where no record is behind the chart, so no step has a state to read. */
  readonly showLegend = input(true);

  protected readonly lanes = LANES;
  protected readonly marker = MARKER;
  protected readonly stateLabel = STATE_LABEL;

  protected readonly rows = computed(() =>
    this.journey().phases.map((phase) => ({
      ...phase,
      lanes: LANES.map((lane) => phase.steps.filter((s) => s.lane === lane.key)),
    })),
  );

  protected emailLabel(step: JourneyStep): string {
    const who = step.emails.map((e) => (e === 'capx' ? 'CapX Ops' : 'the client'));
    return `Emails ${who.join(' and ')}`;
  }
}
